import React from 'react'
import { useModals, useAuth, usePage } from 'hooks'
import CreateCompanyModal from 'components/company/create/CreateCompanyModal'
import OrganizationHeader from 'components/organization/OrganizationHeader'

export default function CompaniesHeader() {
  const { openModal } = useModals()
  const { currentOrg, freeTrial } = useAuth()
  const { pageProps } = usePage()

  // Only allow new clients to be created if the user has a subscription, is on a free trial,
  // or is on the free plan with room for another active company
  const allowClientCreation =
    currentOrg?.organizationSubscriptions?.nodes?.[0]?.status === 'active' ||
    freeTrial ||
    pageProps?.activeCompanyCount < 1

  const handleCreateCompany = () => {
    if (!allowClientCreation) return
    openModal(CreateCompanyModal, {}, 'full')
  }

  return (
    <OrganizationHeader
      button={{
        onClick: handleCreateCompany,
        text: '+ New Client',
        disabled: !allowClientCreation,
      }}
    />
  )
}
